import { Cell } from './Cell';
import { RuleExecutionResult } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Events';
import './EvaluationCell.less';
import { EvaluationColumn } from 'domains/designers/TruthTable/columns';
import { Icon } from 'components/icons/Icon';

interface IEvaluationCellProps {
  //TODO alex: make consistent names "evaluation" vs "execution"
  executionResult: RuleExecutionResult | null;
}

/**
 * Indicates a row evaluation result by showing "True" or "False" icon inside a cell.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function EvaluationCell({ executionResult }: IEvaluationCellProps) {
  return (
    <EvaluationColumn>
      <Cell className="tt-evaluation-cell">
        {executionResult === RuleExecutionResult.Failure && (
          <Icon className="tt-evaluation-cell__failure-icon" size={'input'} />
        )}
        {executionResult === RuleExecutionResult.Success && (
          <Icon className="tt-evaluation-cell__success-icon" size={'input'} />
        )}
      </Cell>
    </EvaluationColumn>
  );
}
